import api from "../../api.js";

export async function listPractitioners() {
  const res = await api.get("/api/profiles/practitioners");
  const rows = res.data?.data || [];
  return rows.map((r) => {
    const id = r.practitionerid ?? r.PRACTITIONERID ?? r.id;
    const title = r.title ?? r.TITLE ?? "";
    const surname = r.surname ?? r.SURNAME ?? "";
    const firstname = r.firstname ?? r.FIRSTNAME ?? "";
    const practicenumber = r.practicenumber ?? r.PRACTICENUMBER ?? r.practiceNumber ?? "";
    const label = [title, surname, firstname].filter(Boolean).join(" ");
    return { id, label, practicenumber };
  });
}

export async function listMedicalSchemeOptions() {
  const res = await api.get("/api/profiles/medical-scheme-options");
  const rows = res.data?.data || [];
  return rows.map((r) => {
    const id = r.id ?? r.ID;
    const schemename = r.schemename ?? r.SCHEMENAME ?? "";
    const membernumberformat = r.membernumberformat ?? r.MEMBERNUMBERFORMAT ?? "";
    return { id, schemename, membernumberformat };
  });
}

export async function listPatients({ search = "", page = 1, pageSize = 10 } = {}) {
  const params = { search, page: String(page), pageSize: String(pageSize) };
  const res = await api.get("/api/profiles/patients", { params });
  return {
    data: res.data?.data || [],
    total: Number(res.data?.total || 0),
    page: Number(res.data?.page || page),
    pageSize: Number(res.data?.pageSize || pageSize),
  };
}

export async function getProfileByPatient(patientId) {
  const res = await api.get(`/api/profiles/profile/${encodeURIComponent(patientId)}`);
  return res.data || {};
}

export async function createProfile(payload) {
  const res = await api.post("/api/profiles/create", payload);
  return res.data;
}

export async function validateMainMemberId(idNumber) {
  const res = await api.post("/api/profiles/validate-main-id", { idnumber: idNumber });
  return res.data;
}